import React from 'react';
type PillTone = 'neutral' | 'blue' | 'amber' | 'red' | 'green' | 'purple';
const toneClasses: Record<PillTone, string> = {
  neutral: 'bg-slate-100 dark:bg-[#2a2a2a] text-slate-600 dark:text-[#a3a3a3] border-slate-200 dark:border-[#333]',
  blue: 'bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300 border-blue-100 dark:border-blue-800',
  amber: 'bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-300 border-amber-100 dark:border-amber-800',
  red: 'bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300 border-red-100 dark:border-red-800',
  green: 'bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-300 border-emerald-100 dark:border-emerald-800',
  purple: 'bg-purple-50 dark:bg-purple-900/20 text-purple-700 dark:text-purple-300 border-purple-100 dark:border-purple-800'
};
interface StatusPillProps {
  label: string;
  tone?: PillTone;
}
export function StatusPill({
  label,
  tone = 'neutral'
}: StatusPillProps) {
  return <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold whitespace-nowrap ${toneClasses[tone]}`} data-id="element-197">
      {label}
    </span>;
}
// Mappers so every surface reads the same way.
export function transcriptionTone(status: string): PillTone {
  switch (status) {
    case 'Transcribed':
      return 'green';
    case 'Queued':
      return 'blue';
    case 'Flagged':
      return 'amber';
    case 'Failed':
      return 'red';
    default:
      return 'neutral';
  }
}
export function reviewTone(status: string): PillTone {
  switch (status) {
    case 'Reviewed':
      return 'green';
    case 'Corrected':
      return 'blue';
    case 'Dismissed':
      return 'neutral';
    case 'Follow-up':
      return 'amber';
    default:
      return 'neutral';
  }
}
export function edgeTone(_edge: string): PillTone {
  return 'red';
}